import { render, staticRenderFns } from "./PaymentPromptDetailListTable.vue?vue&type=template&id=01baec85&scoped=true&lang=pug"
import script from "./PaymentPromptDetailListTable.vue?vue&type=script&lang=js"
export * from "./PaymentPromptDetailListTable.vue?vue&type=script&lang=js"
import style0 from "./PaymentPromptDetailListTable.vue?vue&type=style&index=0&id=01baec85&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01baec85",
  null
  
)

export default component.exports